import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component WorkloadIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <WorkloadIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <WorkloadIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const WorkloadIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="WorkloadIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        stroke="#F4F5F7"
        strokeWidth={0.1}
        opacity={0.01}
        d="M.05.05h23.9v23.9H.05z"
      />
      <path d="M22 12a.834.834 0 00-.41-.717l-1.959-1.158 1.96-1.157a.834.834 0 000-1.435l-9.167-5.417a.833.833 0 00-.848 0L2.409 7.533a.833.833 0 000 1.435l1.96 1.157-1.96 1.158a.833.833 0 000 1.435l1.96 1.157-1.96 1.158a.833.833 0 000 1.435l9.167 5.416a.829.829 0 00.848 0l9.167-5.416a.834.834 0 000-1.435l-1.96-1.158 1.96-1.157A.834.834 0 0022 12zM12 3.801l7.528 4.45L12 12.698 4.471 8.25 12 3.801zm-.424 10.583a.829.829 0 00.848 0l5.57-3.29 1.535.907L12 16.449 4.471 12l1.536-.907 5.569 3.291zm7.952 1.366L12 20.2l-7.529-4.45 1.536-.907 5.57 3.29a.829.829 0 00.848 0l5.57-3.29 1.533.907z" />
    </svg>
  )
);
WorkloadIcon.displayName = "WorkloadIcon";
export default WorkloadIcon;
